const NAMESPACE = `jbp-sob-data--quarterly-view`
const NAMESPACE_COLUMNS = `${NAMESPACE}--column`

export const TRANSLATION_KEYS = {
  hasNoRevenueTooltip: `${NAMESPACE}--tooltip--has-no-revenue`,
  negativeRevenueTooltip: `${NAMESPACE}--tooltip--negative-revenue`,
  hasNoSobTooltip: `${NAMESPACE}--tooltip--has-no-sob`,

  chart: { barChartTitle: `${NAMESPACE}--chart-bar-chart-title` },

  topHeader: {
    commercialColumnsHeader: `${NAMESPACE_COLUMNS}--top-header-commercial`,
    sobColumnsHeader: `${NAMESPACE_COLUMNS}--top-header-sob`,
    resultsColumn: `${NAMESPACE_COLUMNS}--top-header-results`,
    tamColumnsHeader: `${NAMESPACE_COLUMNS}--top-header-tam`,
  },
  columns: {
    market: `${NAMESPACE_COLUMNS}--market`,
    partnersCount: `${NAMESPACE_COLUMNS}--partners-count`,
    amplifyCoverage: `${NAMESPACE_COLUMNS}--amplify-coverage`,
    prevYearSobBaseline: `${NAMESPACE_COLUMNS}--prev-year-sob-baseline`,
    currYearSobPlan: `${NAMESPACE_COLUMNS}--curr-year-sob-plan`,
    yoyBaseline: `${NAMESPACE_COLUMNS}--yoy-baseline`,
    currYearSobActual: `${NAMESPACE_COLUMNS}--curr-year-sob-actual`,
    currYearSobExpectedExit: `${NAMESPACE_COLUMNS}--curr-year-sob-expected-exit`,
    yoyPp: `${NAMESPACE_COLUMNS}--yoy-pp`,
    qoqPp: `${NAMESPACE_COLUMNS}--qoq-pp`,
    vsPlan: `${NAMESPACE_COLUMNS}--vs-plan`,
    prevYearSalesActuals: `${NAMESPACE_COLUMNS}--prev-year-sales-actuals`,
    currYearSalesPlan: `${NAMESPACE_COLUMNS}--curr-year-sales-plan`,
    yoyRevenue: `${NAMESPACE_COLUMNS}--yoy-revenue`,
    currYearActuals: `${NAMESPACE_COLUMNS}--curr-year-actuals`,
    currYearExpectedExit: `${NAMESPACE_COLUMNS}--curr-year-expected-exit`,
    salesPerf: `${NAMESPACE_COLUMNS}--sales-perf`,
    yoyGrowth: `${NAMESPACE_COLUMNS}--yoy-growth`,
    prevYearQuarterTamActuals: `${NAMESPACE_COLUMNS}--prev-year-quarter-tam`,
    currYearQuarterTamPlan: `${NAMESPACE_COLUMNS}--curr-year-quarter-tam`,
    currYearQuarterTamActuals: `${NAMESPACE_COLUMNS}--curr-year-quarter-tam-actuals`,
    currYearQuarterTamExpectedExit: `${NAMESPACE_COLUMNS}--curr-year-quarter-tam-expected-exit`,
    partnerTamYoy: `${NAMESPACE_COLUMNS}--partner-tam-yoy`,
    partnerTamActualsYoy: `${NAMESPACE_COLUMNS}--partner-tam-actuals-yoy`,
    partnerTamExpectedExitYoy: `${NAMESPACE_COLUMNS}--partner-tam-expected-exit-yoy`,
  },
}
